import { crudMdActions } from "@/services/crud-md-actions";
import { getListActions } from "@/services/crud-md-actions/getListActions";
import { createActions } from "@/services/crud-md-actions/createActions";
import apiClient from "@/services/ApiClient";

const name = "portfolios";

export default {
  name,
  ...crudMdActions(name),
  tab: { getListActions, createActions },
  getEditor(portfolioId) {
    return apiClient.get(`/portfolios/${portfolioId}/editor`);
  },
  updateEditor(portfolioId, data) {
    return apiClient.put(`/portfolios/${portfolioId}/editor`, data);
  },
  getEditorTypes() {
    return apiClient.get("/portfolios/editor/types");
  },
  searchEditor(params) {
    return apiClient.get("/portfolios/editor/search", { params });
  },
  getActiveCourses() {
    return apiClient.get("/courses/active");
  },
  getCoursePortfolios(courseId) {
    return apiClient.get(`/courses/${courseId}/portfolios/list`);
  },
};
